import { create } from 'zustand'

import { getLoginRedirectUrl, getExchangeAuthCode, refreshToken, signOut } from './provider'

import type { UseAuthenticationProps } from './types'

export const useAuthentication = create<UseAuthenticationProps>((set) => ({
  loginRedirectUrlLoading: false,
  setLoginRedirectUrlLoading: (value) => set({ loginRedirectUrlLoading: value }),

  isAuthenticated: false,
  setIsAuthenticated: (value) => set({ isAuthenticated: value }),

  isSignedOutLoading: false,
  setIsSignedOutLoading: (value) => set({ isSignedOutLoading: value }),

  getLoginRedirectUrl,
  getExchangeAuthCode,
  refreshToken,
  signOut
}))
